import { render, staticRenderFns } from "./retang.vue?vue&type=template&id=6fb34849&scoped=true"
import script from "./retang.vue?vue&type=script&lang=js"
export * from "./retang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb34849",
  null
  
)

export default component.exports